import pink from 'assets/images/jackpot/decor/pink.png';
import green from 'assets/images/jackpot/decor/green.png';
import blue from 'assets/images/jackpot/decor/blue.png';

import blurredBlue from 'assets/images/jackpot/decor/blurredBlue.png';
import blurredPink from 'assets/images/jackpot/decor/blurredPink.png';
import blurredGreen from 'assets/images/jackpot/decor/blurredGreen.png';

import blueWithConfetti from 'assets/images/jackpot/decor/blueWithConfetti.png';
import pinkWithConfetti from 'assets/images/jackpot/decor/pinkWithConfetti.png';

export const JackpotGemsDefaultPack = () => (
  <>
    <img src={pink} alt="" className="pink" />
    <img src={green} alt="" className="green" />
    <img src={blurredPink} alt="" className="bluredPink" />
    <img src={blurredBlue} alt="" className="bluredBlue" />
    <img src={blurredGreen} alt="" className="bluredGreen" />
  </>
);

export const JackpotGemsWinPack = () => (
  <>
    <img src={blueWithConfetti} alt="" className="blueWithConfetti" />
    <img src={pinkWithConfetti} alt="" className="pinkWithConfetti" />
  </>
);

export const JackpotBannerPack = () => (
  <>
    <img src={blue} alt="" className="blue" />
    <img src={blurredBlue} alt="" className="blurredBlue" />
    <img src={blurredPink} alt="" className="blurredPink" />
  </>
);
